import template from './trip-traveller-allocation-recommendation.html';

const DIRECTIVE_NAME = TripTravellerAllocationRecommendation.DIRECTIVE_NAME = 'ktTripTravellerAllocationRecommendation';
export default function TripTravellerAllocationRecommendation() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TripTravellerAllocationRecommendationController,
        controllerAs: '$ctrl',
        scope: {
            flightRecommendation: `=${DIRECTIVE_NAME}`,
            selectedSeats: `=${DIRECTIVE_NAME}SelectedSeats`,
            tripDetails: `=${DIRECTIVE_NAME}TripDetails`,
            isHold: `=?${DIRECTIVE_NAME}IsHold`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function TripTravellerAllocationRecommendationController(
    userService,
    tripTravellerAllocationRecommendationService,
    tripItemFlightRecommendationService,
    seatmapAvailabilityService,
    moment,
    l10nService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        isSeatmapAvailableForFlightGroup: seatmapAvailabilityService.isSeatmapAvailableForFlightGroup,
        moment,
        l10nService,
    });

    function $onInit() {
        vm.rs = userService.getRegionalSettings();
        vm.flightRoute = tripTravellerAllocationRecommendationService.getFlightRecommendationAirportCodeRoute(vm.flightRecommendation);
        vm.flightRecommendationDepartureDate = tripItemFlightRecommendationService.getRecommendationDepartureDate(vm.flightRecommendation);
        vm.flightRecommendationArrivalDate = tripItemFlightRecommendationService.getRecommendationArrivalDate(vm.flightRecommendation);
        vm.isHoldUntilVisible = !!(vm.isHold && vm.flightRecommendation.HoldUntil);
        vm.isOneWayTrip = tripItemFlightRecommendationService.isOneWayTrip(vm.flightRecommendation);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-traveller-allocation/trip-traveller-allocation-recommendation/trip-traveller-allocation-recommendation-component.js